import { ListItem, ListItemButton, ListItemIcon, ListItemText, styled } from '@mui/material';
import { Link as RouterLink, useLocation } from 'react-router-dom';
import * as Icons from '../../components/icons';

type IconName = keyof typeof Icons;

const StyledListItem = styled(ListItem)(({ theme }) => ({
  '& .MuiListItemButton-root': {
    borderRadius: '12px',
    margin: '4px 8px',
    '&:hover': {
      background: theme.palette.primary.main + '20',
    },
  },
  '& .Mui-selected': {
    background: theme.palette.primary.main + '30 !important',
    '& .MuiListItemIcon-root': {
      color: theme.palette.primary.main,
    },
  },
}));

interface SidebarItemProps {
  text: string;
  icon: IconName;
  path: string;
}

export const SidebarItem = ({ text, icon, path }: SidebarItemProps) => {
  const location = useLocation();
  const IconComponent = Icons[icon];
  return (
    <StyledListItem disablePadding>
      <ListItemButton 
      component={RouterLink} 
      to={path}
      selected={location.pathname === path}>
        <ListItemIcon>
        <IconComponent />
        </ListItemIcon>
        <ListItemText primary={text} />
      </ListItemButton>
    </StyledListItem>
  );
};